import { render } from "./Download.vue?vue&type=template&id=4afe48a6&scoped=true"
import script from "./Download.vue?vue&type=script&lang=js"
export * from "./Download.vue?vue&type=script&lang=js"

import "./Download.vue?vue&type=style&index=0&id=4afe48a6&scoped=true&lang=css"

import exportComponent from "/home/pdu/dbesslnc2-20251202/dbesslnc2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afe48a6"]])

export default __exports__